import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatListModule} from "@angular/material/list";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatTooltipModule} from "@angular/material/tooltip";
import {HttpService} from "../../services/http/http.service";
import { DizionarioView } from 'src/app/model/dizionario-view';
import { BasicResponse } from '@model';
import {MatSnackBar} from '@angular/material/snack-bar';
import { AreaView } from 'src/app/model/area-view';
import { ConfirmDialog } from '../confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'details-area-dialog',
  templateUrl: './details-area-dialog.component.html',
  styleUrls: ['./details-area-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
  ],
})
export class DetailsAreaDialog implements OnInit {
  creazione: boolean = false;
  modifica: boolean = false;
  refresh: boolean = false;
  warningArchiviazione: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DetailsAreaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private api: HttpService,
    private readonly snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.creazione = this.data.creazione ?? false;
    this.modifica = this.data.modifica ?? false;
    this.data.statiAree = [{ id: 1, descrizione: 'BOZZA' }];
    if (this.modifica) {
      this.getStatiAree();
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.refresh);
  }

  getStatiAree() {
    this.api.getStatiAree().subscribe({
      next: (response: BasicResponse<DizionarioView[]>) => {
        this.data.statiAree = response.result;
      },
    });
  }

  checkSalva() {
    if (this.warningArchiviazione) {
      const title = 'Conferma archiviazione';
      const text = 'Selezionando lo stato "ARCHIVIATA" tutte le competenze indipendenti e i profili associati saranno archiviati.\nSei sicuro di voler procedere?';
      const dialogRef = this.dialog.open(ConfirmDialog, {
        data: { title, text },
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result && result.confirm) {
          this.salvaArea(() => {
            this.api.getAssociazioniArea(this.data.area.id).subscribe({
              next: (response: any) => {
                this.data.area.numeroAssociazioni = response.result;
              }
            });
          });
        }
      });
    } else {
      this.salvaArea();
    }
  }

  salvaArea(afterSave?: () => void) {
    this.api.salvaArea(this.data.area).subscribe({
      next: (response: BasicResponse<AreaView>) => {
        const associazioni: any = this.data.area?.numeroAssociazioni;
        this.data.area = response.result;
        if (associazioni) {
          this.data.area.numeroAssociazioni = associazioni;
        }
        this.snackBar.open('Area salvata', 'close', {
          panelClass: 'successSnack',
        });
        this.refresh = true;
        if (afterSave) {
          afterSave();
        }
      },
    });
  }

  checkForm() {
    return this.data.area.descrizione && this.data.area.idAreaSep;
  }

  onStatoAreaChange(event: any) {
    const statoSelezionato = this.data.statiAree.find(
      (stato: any) => stato.id === event.value,
    );
    if (statoSelezionato.id === 3) { // stato "ARCHIVIATA"
      this.warningArchiviazione = true;
    }
  }

  get titolo(): string {
    if (this.creazione) return 'NUOVA AREA';
    if (this.modifica) return 'MODIFICA AREA';
    return 'DETTAGLIO AREA';
  }
}
